import { render, staticRenderFns } from "./LinhasDoPagamentoTabela.vue?vue&type=template&id=5738763e&scoped=true"
import script from "./LinhasDoPagamentoTabela.vue?vue&type=script&setup=true&lang=js"
export * from "./LinhasDoPagamentoTabela.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LinhasDoPagamentoTabela.vue?vue&type=style&index=0&id=5738763e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5738763e",
  null
  
)

export default component.exports